var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainSettingsEditAdmin',{attrs:{"ms":_vm.ms},on:{"changeShippingCompaniesSettings":_vm.changeShippingCompaniesSettings}})
}
var staticRenderFns = []

export { render, staticRenderFns }